import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ListPartnerReferrals,
  ListPartnerReportCampaigns,
  ListPartnerReportReferrals,
  PartnerReferrals,
  PartnerReportCampaigns,
  PartnerReportReferrals
} from '@models/partner/analytics/partner-analytics';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@env';

@Injectable({
  providedIn: 'root'
})
export class PartnerAnalyticsService {
  private readonly baseUrl;
  private urlPrefix = 'partner-analytics/';

  constructor(private http: HttpClient) {
    this.baseUrl = environment.serverBaseUrl;
  }

  getReportCampaigns(month?: string, year?: string): Observable<PartnerReportCampaigns> {
    let queryParams = new HttpParams();
    queryParams = this.setQueryParamFilterDate(queryParams, month, year);
    const url = this.baseUrl + this.urlPrefix + 'report-campaigns';
    return this.http
      .get<Response>(url, { params: queryParams })
      .pipe(
        map(data => {
          return ListPartnerReportCampaigns.deserialize({
            data: (data && (data as any) ? ((data as any) as Array<PartnerReportCampaigns>) : []).map(data2 =>
              PartnerReportCampaigns.deserialize(data2)
            ),
            total: (data as any).length
          });
        })
      );
  }

  getListReferrals(
    page?: number,
    size?: number,
    sortColumn?: string,
    sortDirection?: string,
    month?: string,
    year?: string
  ): Observable<PartnerReferrals> {
    let queryParams = this.initQueryParamsPage(page, size, sortColumn, sortDirection);
    queryParams = this.setQueryParamFilterDate(queryParams, month, year);
    const url = this.baseUrl + this.urlPrefix + 'list-referrals';
    return this.http
      .get<Response>(url, { params: queryParams })
      .pipe(map(data => ListPartnerReferrals.deserialize(data)));
  }
  getListReportReferrals(
    page?: number,
    size?: number,
    sortColumn?: string,
    sortDirection?: string,
    month?: string,
    year?: string
  ): Observable<PartnerReportReferrals> {
    let queryParams = this.initQueryParamsPage(page, size, sortColumn, sortDirection);
    queryParams = this.setQueryParamFilterDate(queryParams, month, year);
    const url = this.baseUrl + this.urlPrefix + 'report-referrals';
    return this.http
      .get<Response>(url, { params: queryParams })
      .pipe(map(data => ListPartnerReportReferrals.deserialize(data)));
  }

  private initQueryParamsPage(page?: number, size?: number, sortColumn?: string, sortDirection?: string): HttpParams {
    let queryParams = new HttpParams();
    if (page) {
      queryParams = queryParams.set('page', String(page));
    }
    if (size) {
      queryParams = queryParams.set('size', String(size));
    }
    if (sortColumn) {
      queryParams = queryParams.set('sortColumn', String(sortColumn));
    }
    if (sortDirection) {
      queryParams = queryParams.set('sortDirection', String(sortDirection));
    }

    return queryParams;
  }
  private setQueryParamFilterDate(queryParams: HttpParams, month?: string, year?: string) {
    if (month) {
      queryParams = queryParams.set('month', month);
    }
    if (year) {
      queryParams = queryParams.set('year', year);
    }
    return queryParams;
  }
}
